<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-star`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.86914 15.4971C7.95173 15.537 8.04831 15.5371 8.13086 15.4971C8.22582 15.4509 8.29518 15.3043 8.43359 15.0117L10.0615 11.5703L13.8545 11.8818C14.1775 11.9083 14.3393 11.9215 14.4268 11.8623C14.5028 11.8108 14.551 11.7264 14.5576 11.6348C14.5649 11.5294 14.4723 11.3961 14.2881 11.1299L12.1221 8L14.2881 4.87012C14.4725 4.60367 14.5651 4.47062 14.5576 4.36523C14.551 4.27368 14.5027 4.19023 14.4268 4.13867C14.3393 4.07938 14.1776 4.09266 13.8545 4.11914L10.0615 4.42969L8.43359 0.989258C8.29502 0.696302 8.22591 0.549082 8.13086 0.50293C8.04835 0.462909 7.95171 0.463063 7.86914 0.50293C7.77406 0.549047 7.70403 0.696239 7.56543 0.989258L5.93848 4.42969L2.14453 4.11914C1.82161 4.09268 1.65973 4.0794 1.57227 4.13867C1.49646 4.19024 1.448 4.27377 1.44141 4.36523C1.4339 4.4706 1.52661 4.60377 1.71094 4.87012L3.87695 8L1.71094 11.1299C1.52673 11.3961 1.43409 11.5294 1.44141 11.6348C1.44801 11.7264 1.49628 11.8107 1.57227 11.8623C1.65972 11.9216 1.82165 11.9083 2.14453 11.8818L5.93848 11.5703L7.56543 15.0117C7.70397 15.3046 7.77408 15.451 7.86914 15.4971Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillStar',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
